// services/api.js
// Client-side wrapper that talks to the Cloudflare Pages Function.
// NOTE: No OpenAI imports and no API keys here anymore.

const API_ROUTE = "/api/promptimize";

export async function optimizePrompt(promptText) {
  if (!promptText || typeof promptText !== "string") {
    throw new Error("Prompt text must be a non-empty string.");
  }

  const response = await fetch(API_ROUTE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ prompt: promptText })
  });

  if (!response.ok) {
    let message = "Failed to optimize prompt.";
    try {
      const err = await response.json();
      if (err?.error) {
        message = err.error;
      }
    } catch (_) {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }

  const data = await response.json();

  return {
    optimizedPrompt: data.optimizedPrompt ?? "",
    explanation: data.explanation ?? ""
  };
}